


'use client';

import React from 'react';
import Dropdown from './dropdown';
import { Link } from '@/i18n/routing'; // Use next-intl's Link
import { useLocale } from 'next-intl';
import { useRouter } from 'next/navigation';
import {useTranslations} from 'next-intl';

const LanguageSelect: React.FC = () => {
  const t = useTranslations('Menu');


  const ManOptions = [
    { code: '1', name: t('djellaba') , category:'jlb'},
    { code: '2', name: t('mansouria')  , category:'mnsr'},
    { code: '3', name: t('kaftane') , category:'kftn'},
    { code: '4', name: t('bedi\'iya') , category:'bdia'},
    { code: '5', name: t('djabadour') , category:'djr'},
    { code: '6', name: t('melaya') , category:'mlya'},
  ];



  const router = useRouter(); // Initialize the router
  const locale = useLocale(); // Get the current locale

  const handleSelectClothing = (option: string) => {
   // console.log('Selected Clothing:', option);
  };

  const handleSelectShoes = (option: string) => {
   // console.log('Selected Shoes:', option);
  };

  // Function to handle navigation with query parameters
  const handleNavigateWithQuery = ( query: string) => {
    // Include the locale and query parameters in the URL
    router.push(`/${locale}/p?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="custom:flex gap-6 uppercase font-playfair text-lg select-none tracking-wide font-extrabold hidden text-yel">
      <Link href="/blog" rel="preload" >
        <p className="hover:text-gold text-white font-normal">{t('blog')}</p>
      </Link>
     
        <Link href="/contact-us" rel="preload" >
          <p className="hover:text-gold text-white font-normal">{t('contact')}</p>
        </Link>
    
      <Dropdown title={t('categories')} options={ManOptions} onSelect={handleSelectClothing} />
  

      <Link href="/product" rel="preload" >
        <p className="hover:text-gold text-white font-normal">{t('products')}</p>
      </Link>
    </div>
  );
};

export default LanguageSelect;







/**
 * <Dropdown title={t('woman')} options={WomanOptions} onSelect={handleSelectShoes} />
      <Dropdown title={t('rackets')} options={RacketsOptions} onSelect={handleSelectShoes} />
      <Dropdown title={t('accessories')} options={AccessoriesOptions} onSelect={handleSelectShoes} />

 */